import type {ResponseAnnotation} from '@reados/contracts';
import {consumeAttachments,type DraftConversationAttachment} from './conversation-attachments';
import {consumeAnnotations} from './response-annotations';

export interface ComposerDraft {draft:string;annotations:ResponseAnnotation[];attachments?:DraftConversationAttachment[]}
export interface ComposerAcceptanceOptions {draftAlreadyConsumed?:boolean}
/** The pending tab changes its address after acceptance; preserve in-flight edits. */
export function pendingComposerAfterAcceptance(current:ComposerDraft,submitted:ComposerDraft,options:ComposerAcceptanceOptions={}):ComposerDraft {
 return {draft:!options.draftAlreadyConsumed&&current.draft===submitted.draft?'':current.draft,annotations:consumeAnnotations(current.annotations,submitted.annotations),...(current.attachments||submitted.attachments?{attachments:consumeAttachments(current.attachments??[],submitted.attachments??[])}:{})};
}
